{
  "receiving": {
    "search": {
      "label": "Search by order number"
    },
    "notIssuedTitle": "This order has not been issued yet",
    "notIssuedBody": "Goods can only be received against an issued purchase order. Once the order has been issued to the supplier, come back here to record what arrives.",
    "cancelledTitle": "This order was cancelled",
    "cancelledBody": "Nothing more can be received against a cancelled order. Anything that arrived before the cancellation is listed below.",
    "openOrder": "Open the order"
  }
}
